const GlobalOverrides = window.clueOverrides || {}
const envs = process.env

const config = {
  servicesHost: GlobalOverrides.SERVICES_HOST || envs.REACT_APP_SERVICES_HOST,
  httpTimeout: GlobalOverrides.httpTimeout || envs.REACT_APP_HTTP_TIMEOUT || 0
}

export default config
